"use strict"

import React from "react"
import {observer} from "mobx-react"
import XsInput from "../../../../../global/ui/xsInput/xsInput"
import XsAutocomplete from "../../../../../global/ui/xsInput/xsAutocomplete"
import XsChipForm from "../../../../../global/ui/xsChipForm/xsChipForm"
import XsChip from "../../../../../global/ui/xsChip/xsChip"
import XsIconButton from "../../../../../global/ui/xsButton/xsIconButton"
import AddIcon from "@material-ui/icons/Add"
import RouterStore from "../../../../../global/store/RouterStore"
import api from "../../../actions/api"
import {FormattedMessage} from "react-intl"
import PatientOperationStore from "../../../stores/PatientOperationStore"
import DeliveriesFormAddItems from "./deliveriesFormAddItems"
import GlobalStore from "../../../../../global/store/GlobalStore"
import SearchSelect from "../../../../../global/ui/xsSearchSelect/xsSearchSelect"
import XsDateTimePicker from "../../../../../global/ui/xsDateTimePicker/xsDateTimePicker"
import moment from "moment"
import XsAutocompleteLocal from "../../../../../global/ui/xsInput/xsAutocompleteLocal"
import RegisterCacheStore from "../../../../../global/store/RegistersCacheStore"
import XsConfirmationDialog from "../../../../../global/ui/xsDialog/xsConfirmationDialog"
import PatientRecordStore from "../../../stores/PatientRecordStore"

@observer
export default class DeliveriesForm extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			showSecondChip: {}
		}
		if (isNotEmpty(props.form.$("deliveriesFormAddItems").value)) {
			PatientOperationStore.deliveriesAddItemChips = JSON.parse(props.form.$("deliveriesFormAddItems").value)
		}
	}

	handleDeliveryChange = (form, name, code_ext) => {
		let values = form.get("value")
		if (isSafe(name)) {
			values.col1NameExt = name
		}
		if (isSafe(code_ext)) {
			values.col1CodeExt = code_ext
		}
		form.set(values)
	}

	handleDeliveryFocus = () => {
		if (
			isSafe(PatientOperationStore.deliveriesChipsForm) &&
			typeof PatientOperationStore.deliveriesChipsForm.handleFocus == "function"
		)
			PatientOperationStore.deliveriesChipsForm.handleFocus()
	}

	handlePayerTypeChanged = (form) => {
		let paymentType = form.fields.get("colPaymentType")
		let delivery_extension = form.fields.get("delivery_extension")
		if (isSafe(paymentType) && paymentType.value == "S") {
			if (isSafe(delivery_extension)) {
				delivery_extension.set("rules", "required")
			}
		} else if (isSafe(paymentType)) {
			if (isSafe(delivery_extension)) {
				delivery_extension.set("rules", "")
			}
		}
	}

	handleDeliveryExtensionChanged = (form, opening) => {
		let delivery_extension = form.fields.get("delivery_extension")
		let dateField = form.fields.get("colDateOfRequest")
		let delExtObj = null

		if (isNotEmpty(delivery_extension.value)) {
			delExtObj = GlobalStore.CL["deliveryExtension"].find((row) => row._id == delivery_extension.value)
			if (isSafe(delExtObj) && delExtObj.code_ext == "VYZI") {
				if (isSafe(dateField)) {
					dateField.set("rules", "required")
				}
			} else if (isSafe(delivery_extension)) {
				dateField.set("rules", "")
			}
		} else {
			dateField.set("rules", "")
		}
		if (!opening) {
			this.forceUpdate()
		}
	}

	handleInsureTypeChanged = (form) => {
		const insureeType = form.fields.get("col4")
		const sendingType = form.fields.get("colSendingType")
		if (insureeType.value == "N" && isEmpty(sendingType.value)) {
			sendingType.value = "A"
		}
	}

	render() {
		return (
			<div>
				<SearchSelect
					items={PatientRecordStore.serviceData.map((resource) => {
						return {label: resource.name_ext, value: resource.code}
					})}
					onChange={(obj) => {
						PatientOperationStore.providedServicesSearchValue = obj
						PatientOperationStore.addProvidedServices(this.props.form, obj)
					}}
					value={PatientOperationStore.providedServicesSearchValue}
					hideLabel={true}
					placeholder={<FormattedMessage id="Patient.form.patientrecord.deliveriesFromService" />}
					required
				/>
				<SearchSelect
					items={GlobalStore.CL["senderType"].map((resource) => {
						return {label: resource.name_ext, value: resource.code}
					})}
					onChange={(obj) => {
						PatientOperationStore.insertSendingTypeToDelivieries(this.props.form, obj)
						PatientOperationStore.defaultSendingType = obj
					}}
					value={PatientOperationStore.defaultSendingType}
					hideLabel={true}
					placeholder={<FormattedMessage id="Common.label.insertSendingType" />}
					required
				/>
				<div>
					<FormattedMessage id="Patient.form.patientrecord.deliveries" />
				</div>
				<XsChipForm
					ref={(chipForm) => {
						PatientOperationStore.deliveriesChipsForm = chipForm
					}}
					field={this.props.chipFormField}
					configuration={{
						header: {
							chipsRenderer: (key, dataRow, clickHandler) => (
								<XsChip
									key={key}
									tooltip={isSafe(dataRow["col1NameExt"]) ? dataRow["col1NameExt"]["value"] : ""}
									label={isSafe(dataRow["col1CodeExt"]) ? dataRow["col1CodeExt"]["value"] : ""}
									onClick={(e) => clickHandler(false, e, key)}
								/>
							),

							addButtonRenderer: (clickHandler) => (
								<XsIconButton className="xs-success xs-outline" icon={<AddIcon />} onClick={clickHandler} />
							)
						},
						columns: [
							{
								name: "col1",
								label: <FormattedMessage id="Common.label.delivery" />,
								width: (field, colIdx, index, fields) => {
									return isNotEmpty(fields.get().colDateOfRequest.rules) &&
										fields.get().colDateOfRequest.rules.includes("required")
										? 1
										: 2
								},
								validationRule: "required",
								renderer: (field, index, fieldKey, onChangeHandler, returnFormData, fields, focusRef) => (
									<XsAutocomplete
										ref={(i) => focusRef(i, index)}
										field={field}
										minLengthForSearch="1"
										clearText
										// data={RegisterCacheStore.deliveriesRegister}
										api={api.loadDeliveries}
										searchFilter={"code_ext"}
										loadApi={api.loadSpecificDelivery}
										renderFooterInModal={true}
										inputRenderer={(obj) => obj.code_ext + "-" + obj.name_ext}
										saveValue={(obj) => obj.code}
										postAction={(obj) => {
											this.handleDeliveryChange(
												onChangeHandler(fieldKey),
												obj.code_ext + "-" + obj.name_ext,
												obj.code_ext
											)
										}}
										onMountWithoutLoad={() => {
											setTimeout(() => {
												this.handleDeliveryFocus()
											}, 0)
										}}
										tabindex={+index + 1}
										modalConfig={(textValue, clickHandler) => {
											return {
												columnDefs: {
													code_ext: {
														title: <FormattedMessage id="Patient.form.patientrecord.deliveryTable.code_ext" />,
														design: {
															width: "10%"
														},
														type: "string",
														dbName: "code_ext",
														filter: {
															gridWidth: 3,
															defaultValue: "",
															renderElement: "input"
														}
													},
													name_ext: {
														title: <FormattedMessage id="Patient.form.patientrecord.deliveryTable.name_ext" />,
														type: "string",
														dbName: "search_column",
														design: {
															width: "90%"
														},
														filter: {
															gridWidth: 3,
															defaultValue: textValue,
															renderElement: "input"
														}
													}
												},
												options: {
													showCursor: true,
													onRowClick: (dataRow) => {
														clickHandler(dataRow)
													}
												}
											}
										}}
									/>
								)
							},
							{
								name: "col1NameExt",
								renderer: () => {},
								width: 0
							},
							{
								name: "col1CodeExt",
								renderer: () => {},
								width: 0
							},
							{
								name: "col2",
								label: <FormattedMessage id="Patient.form.patientrecord.diagnosis" />,
								width: 1,
								validationRule: "required|string",
								renderer: (field, index) => (
									<XsAutocompleteLocal
										field={field}
										minLengthForSearch="3"
										clearText
										data={RegisterCacheStore.diagnosisRegister}
										inputRenderer={(obj) => obj.code_ext + " " + obj.name_ext}
										saveValue={(obj) => obj.code}
										firstLoad={() => {
											this.handleDeliveryFocus()
										}}
										tabindex={+index + 1}
									/>
								),
								defaultValue: () => {
									//Prerobit na field
									return isSafe(PatientOperationStore.diagnosisChipsForm) &&
										isSafe(PatientOperationStore.diagnosisChipsForm.getData()) &&
										isSafe(PatientOperationStore.diagnosisChipsForm.getData()["0"]) &&
										PatientOperationStore.diagnosisChipsForm.getData()["0"].col2 === "PRIMARY"
										? PatientOperationStore.diagnosisChipsForm.getData()["0"].col1
										: ""
								}
							},
							{
								name: "col3",
								label: <FormattedMessage id="Delivery.List.Count" />,
								width: 1,
								validationRule: "required|integer|min:1",
								renderer: (field, index) => <XsInput field={field} min="1" type="number" tabindex={+index + 1} />,
								defaultValue: 1
							},
							{
								name: "colPaymentType",
								label: <FormattedMessage id="Common.label.payerType" />,
								width: 1,
								validationRule: "required",
								defaultValue: "Z",
								renderer: (field, index, fieldKey, onChangeHandler) => (
									<SearchSelect
										field={field}
										items={GlobalStore.CL["payerType"]}
										tabindex="-1"
										getOptionLabel={(row) => `${row.code_ext} - ${row.name_ext}`}
										onChange={() => this.handlePayerTypeChanged(onChangeHandler(fieldKey))}
										onClear={() => setTimeout(() => this.handlePayerTypeChanged(onChangeHandler(fieldKey)), 0)}
									/>
								)
							},
							{
								name: "delivery_extension",
								label: <FormattedMessage id="Patient.form.patientrecord.deliveryTable.deliveryExtension" />,
								width: 1,
								validationRule: "",
								renderer: (field, index, fieldKey, onChangeHandler) => (
									<SearchSelect
										field={field}
										tooltipProp="description"
										items={GlobalStore.CL["deliveryExtension"]}
										onChange={() => this.handleDeliveryExtensionChanged(onChangeHandler(fieldKey))}
										onClear={() => setTimeout(() => this.handleDeliveryExtensionChanged(onChangeHandler(fieldKey)), 0)}
									/>
								)
							},
							{
								name: "col4",
								label: <FormattedMessage id="Delivery.List.InsureeType" />,
								width: 1,
								validationRule: "",
								renderer: (field, index, fieldKey, onChangeHandler) => (
									<SearchSelect
										field={field}
										items={GlobalStore.CL["insureeType"]}
										tabindex="-1"
										onChange={() => {
											this.handleInsureTypeChanged(onChangeHandler(fieldKey))
										}}
									/>
								)
							},
							{
								name: "colSendingType",
								label: <FormattedMessage id="Delivery.List.SenderTypyShort" />,
								width: 1,
								validationRule: "",
								renderer: (field) => <SearchSelect field={field} items={GlobalStore.CL["senderType"]} tabindex="-1" />,
								defaultValue: () => {
									// Load z dispenzaru
									if (isSafe(this.props.form) && this.props.form.$("hasDispensaryDiagnosis").value == true) {
										return "D"
									}
									// else if (
									// 	// Load podla lekara
									// 	isSafe(this.props.form) &&
									// 	isNotEmpty(this.props.form.$("doctorPersonnelExpertiseId").value)
									// ) {
									// 	return "S"}
									else if (
										isSafe(PatientOperationStore.defaultSendingType) &&
										isNotEmpty(PatientOperationStore.defaultSendingType.value)
									) {
										//Load zo selectu
										return PatientOperationStore.defaultSendingType.value
									} else {
										return ""
									}
								}
							},
							{
								name: "col5",
								label: <FormattedMessage id="Delivery.List.RefundType" />,
								width: 1,
								validationRule: "",
								renderer: (field) => <SearchSelect field={field} items={GlobalStore.CL["refundType"]} tabindex="-1" />
							},
							{
								name: "col6",
								label: <FormattedMessage id="Delivery.List.MovementShort" />,
								width: 1,
								validationRule: "",
								renderer: (field) => <XsInput field={field} tabindex="-1" />
							},
							{
								name: "colDateOfRequest",
								label: <FormattedMessage id="Patient.form.patientsicknessabs.deliveries.requestdate" />,
								width: 1,
								validationRule: "",
								renderer: (field) =>
									isNotEmpty(field.get("rules")) && field.get("rules").includes("required") ? (
										<XsDateTimePicker field={field} showTimeSelect={false} tabindex="-1" />
									) : null
							},
							{
								name: "col7",
								label: <FormattedMessage id="Common.label.date" />,
								width: 1,
								validationRule: "required",
								renderer: (field) => <XsDateTimePicker field={field} showTimeSelect={false} tabindex="-1" />,
								defaultValue: () => {
									return moment().format(process.env.DB_DATETIME_FORMAT)
								}
							}
						],
						extraRow: {
							name: "addItems",
							label: "",
							renderer: (index, fieldKey) => (
								<DeliveriesFormAddItems
									index={index}
									fieldKey={fieldKey}
									deliveryFormField={this.props.chipFormField}
								/>
							)
						},
						options: {
							showLoadingOnOpening: true,
							disabled: false,
							isFormMode: false,
							showInCenter: true,
							maxWidth: true,
							plusButtonTabindex: (index) => {
								return +index + 1
							},
							onSubmit: (saveForm) => {
								PatientOperationStore.checkDeliverysForConstraints(saveForm)
							},
							onRemoveRow: (index, fieldKey) => {
								PatientOperationStore.deliveriesAddItemChips[fieldKey] = []
								setTimeout(() => {
									Object.keys(PatientOperationStore.deliveriesAddItemChipsForm).forEach((key) => {
										if (key >= fieldKey) {
											if (isSafe(PatientOperationStore.deliveriesAddItemChipsForm[key]))
												PatientOperationStore.deliveriesAddItemChipsForm[key].reloadFromData()
										}
									})
									PatientOperationStore.deliveriesAddItemChipsForm[fieldKey].reloadFromData()
								}, 0)
							},
							onFormOpen: (rowsField, form) => {
								Object.keys(PatientOperationStore.deliveriesAddItemChipsForm).forEach((x) => {
									const idx = +x
									if (isSafe(PatientOperationStore.deliveriesAddItemChipsForm[idx]))
										PatientOperationStore.deliveriesAddItemChipsForm[idx].bindData(
											PatientOperationStore.deliveriesAddItemChips[idx]
										)
								})
								setTimeout(() => {
									let rows = rowsField.get()
									Object.keys(rows).forEach((key) => {
										this.handleDeliveryExtensionChanged(form.$(`rows[${key}]`), true)
									})
								}, 0)
							},
							onFormClose: () => {},
							onFormSave: (values) => {
								this.props.form.$("deliveriesFormAddItems").value = JSON.stringify(
									PatientOperationStore.deliveriesAddItemChips
								)
								PatientOperationStore.checkDeliverysAndSave(
									this.props.form,
									values,
									RouterStore.location.search.replace(/([^0-9])+/, ""),
									this.props.form.$("recordId").value
								)
							},
							deleteButtonConfig: {
								warningDialogText: <FormattedMessage id="Common.label.deleteAllDeliveriesDialog" />,
								buttonTooltip: <FormattedMessage id="Common.label.deleteAllDeliveries" />,
								onDelete: () => {
									this.props.chipFormField.value = "[]"
									PatientOperationStore.deliveriesChips = []
									this.props.form.$("deliveriesFormAddItems").value = "[]"

									Object.keys(PatientOperationStore.deliveriesAddItemChips).forEach((key) => {
										PatientOperationStore.deliveriesAddItemChips[key] = []
									})

									Object.keys(PatientOperationStore.deliveriesAddItemChipsForm).forEach((key) => {
										if (isSafe(PatientOperationStore.deliveriesAddItemChipsForm[key])) {
											PatientOperationStore.deliveriesAddItemChipsForm[key].bindData([])
										}
									})

									//V pripade BODOVAT teda readonly modu sa po vymazani zavola api ktore vymaze vykony aj v databaze
									// if (isNotEmpty(this.props.form.$("recordId").value) && PatientOperationStore.readonlyform) {
									// 	PatientOperationStore.checkDeliverysAndSave(
									// 		this.props.form,
									// 		[],
									// 		RouterStore.location.search.replace(/([^0-9])+/, ""),
									// 		this.props.form.$("recordId").value
									// 	)
									// }
								}
							}
						},
						data: PatientOperationStore.deliveriesChips
					}}
				/>
				{GlobalStore.confirmationDialogOpened == "xsRewriteSendingType" && (
					<XsConfirmationDialog
						name="xsRewriteSendingType"
						type="danger"
						title={<FormattedMessage id="Common.label.warning" />}
						text={<FormattedMessage id="Common.label.rewriteSendingType" />}
						onConfirmation={() => GlobalStore.confirmationDialogParams.rewriteCallback()}
					/>
				)}
			</div>
		)
	}
}
